require('../../modules/es.symbol.match-all');
require('../../modules/es.string.match-all');
var WrappedWellKnownSymbolModule = require('../../internals/well-known-symbol-wrapped');

module.exports = WrappedWellKnownSymbolModule.f('matchAll');
